import { Component, Input, OnInit } from "@angular/core";
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { CMovementOrder } from './../../model/action-tablet.model';
import { TranslationService } from "@sdbn/common";

@Component({
  selector: 'app-action-tablet-movement-order-list',
  templateUrl: './action-tablet-movement-order-list.component.html',
  styleUrls: ['./action-tablet-movement-order-list.component.scss']
})
export class ActionTabletMovementOrderList implements OnInit {


  columnsToDisplay: string[] = ['priority', 'referenceDate', 'scope', 'identifier', 'currentStation', 'targetStation', 'transportReference', 'processingStatus'];
  dataSource: MatTableDataSource<CMovementOrder> = new MatTableDataSource(new Array<CMovementOrder>);

  @Input("movementOrders") set movementOrders(movementOrders: Array<CMovementOrder>) {
    this.dataSource = new MatTableDataSource(movementOrders);
  }


  constructor(public translationService: TranslationService) {

  }
  ngOnInit(): void {

  }
}